var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNaoidentificado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "120px",
    viewBox: "0 0 100 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "il-naoidentificado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 120
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP-benefici\\xE1rio-[SYMPTOM-CHECKER]",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resultado-|-N\\xE3o-encontrado-[SYMPTOMCHECKER]",
    transform: "translate(-228.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "il-naoidentificado",
    transform: "translate(228.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ilustra",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 17,
    y: 105,
    width: 46,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,24.2558594 C32.0819236,22.9706344 29.0908203,11.1337891 33.8661924,4.74657398 C36.2563301,1.54968739 41.1354496,0.841307252 45.269619,1.01514972 L46.1429738,1.05113909 C51.9238316,1.28873425 57.1854105,4.41840389 60.107193,9.35727568 C61.5685941,11.9518811 58.5961914,23.3430176 56.5961914,25.0217285 C56.3111085,27.7952079 34.8676758,31.5344238 32.5,24.2558594 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D89379",
    fillRule: "nonzero",
    cx: 45,
    cy: 22,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,44 L36,42.8333305 C37.8620381,38.3721328 38.6058413,34.0761934 37.8627432,30 L52.0196075,30 C51.9875248,33.1297132 53.4795396,38.543538 55,44 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#59BEC9",
    fillRule: "nonzero",
    points: "68 113.95214 25 117 29.4150401 41.3811933 36.9017819 39.285895 45.3481118 41.1905967 53.7944418 37 59.1694949 38.9051233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7403131,168 L3,161.355071 C11.5459932,132.712341 26.9420091,67.1861792 21.9723826,43.8347834 L37,37 L31.7403131,168 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8749979,86 L7,79.1504421 L16.2744555,51.5867597 C17.3088566,48.7425268 19.2901373,46.3544648 21.8757478,44.8354531 L25,43 L23.1249979,70.7787519 L17.8749979,86 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,162.776241 C83.8228798,168.092412 60.8831738,171.055855 50.8108527,167.343004 C50.0696873,141.405765 48.6161459,68.0390625 53.2813872,37 L70.0050123,43.8501433 L68.4846827,64.4005732 C60.4894288,81.9803477 83.7059133,143.210822 93,162.776241 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero",
    points: "90.8637507 82 80.6362493 78.5587737 67 62.8821704 69.2729179 43 92 75.1175475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0698193,96.6631401 C59.4139375,98.2773713 60.9150811,99.2895268 62.4260434,98.9260952 L71,96.8504017 L69.760826,91 L61.1866914,93.0752996 C59.675465,93.4413475 58.7278003,95.0475271 59.0698235,96.6631401 L59.0698193,96.6631401 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,91 L71.8749979,100 C80.0746686,97.7130573 87.1809669,90.5033152 94,82 L92.1249979,76 L80.5,79 L67,91 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,72 L62.4285714,72 C62.4285714,50.5017942 57.8523994,35.52 53.3928593,35.52 L53,34 C56.9993438,34 59.5490918,40.2352935 60.983746,45.4662395 C62.9288525,52.5576576 64,61.9808374 64,72 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5172579,66 L27,66 C27,46.2617183 31.4489336,34 38,34 L37.6206876,35.5238095 C33.0893527,35.5238095 28.5172579,44.9473593 28.5172579,66 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 63,
    cy: 72,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5555556,76 L21,76 C21,70.4859882 24.1401629,66 28,66 L28,67.5384615 C24.9978858,67.5384615 22.5555556,71.3342856 22.5555556,76 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,76 L33.4444444,76 C33.4444444,71.3342915 31.0021142,67.5384723 28,67.5384723 L28,66 C31.8598371,66 35,70.4859952 35,76 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 33.5,
    cy: 75.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 21.5,
    cy: 75.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8FD16A",
    fillRule: "nonzero",
    points: "3 62 12.4350373 63.7186877 34 95 22.5433782 92.2499289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.786877278,61 C0.495349385,61.0044849 0.229363161,61.1709476 0.0929035545,61.4343108 C-0.0435560517,61.697674 -0.0288154784,62.0161084 0.131362578,62.2651249 L20.1993817,93.3877429 C20.3113643,93.5617335 20.484337,93.6852279 20.6827003,93.7328098 L30.0197542,95.9782724 C30.3420596,96.0558122 30.6777143,95.9217247 30.8631679,95.6413452 C31.0486216,95.3609657 31.0452952,94.9926201 30.8548096,94.7157876 L8.82135869,62.6930233 C8.70068155,62.5168214 8.51643278,62.3968757 8.3091907,62.3596026 L0.937385286,61.0138989 C0.887708794,61.0047861 0.837347262,61 0.786877278,61 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,82.9551234 L13.5622843,89 L22.435113,88.05995 C23.9990807,87.8942818 25.1410967,86.4067896 24.9858772,84.7375431 C24.8306577,83.0682966 23.4369812,81.8494055 21.8730135,82.0150735 L13,82.9551234 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,82.740354 C6.0272813,86.7542599 9.34696536,89.9953514 13.4356835,90 L14.9196574,90 L16,81.1614089 L7.05490396,78 L6,82.740354 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    fillRule: "evenodd",
    cx: 45.5,
    cy: 13,
    rx: 11.5,
    ry: 5
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaoidentificado);
export default __webpack_public_path__ + "static/media/naoidentificado.de5fa7d5.svg";
export { ForwardRef as ReactComponent };